import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Printer } from 'react-feather';
import { Modal, Button } from 'ui';
import { routes } from 'constants/config';
import { useFetch } from 'components/shared/hooks';
import CertificateView from './CertificateView';

const ViewCertificationModal = ({ shown, toggleModal, pathProgressId }) => {
  const inputRef = useRef();
  const { data } = useFetch(routes.CERTIFICATE(pathProgressId));

  if (!data) {
    return null;
  }
  const {
    company,
    completedDate,
    expirationDate,
    expired,
    reassigned,
    startedAt,
    user,
    path,
    urls,
  } = data;

  const handlePrintClicked = () => {
    window.open(urls.print);
  };

  const handleClick = () => {
    inputRef.current.select();
  };

  const handleRenew = () => {
    window.location.href = urls.renew;
  };

  return (
    <Modal
      shown={shown}
      canClickAway={false}
      className="Modal-container ViewCertificationModal bg-gray-lightest"
      onDismiss={toggleModal}
      enableFloatingDismiss
    >
      <Modal.Content>
        <CertificateView
          company={company}
          completedDate={completedDate}
          expirationDate={expirationDate}
          user={user}
          path={path}
          shouldShowConfetti
          expired={expired}
        />
      </Modal.Content>
      <div className="ViewCertificationModal-btnGroup p-32 pt-0">
        <div className="ViewCertificationModal-btns d-f jc-sb">
          <div className="ViewCertificationModal-btns-link d-f">
            <div className="d-f fd-r ai-fe">
              {reassigned && urls.renew && (
                <div className="ViewCertificationModal-closeBtnContainer d-f jc-c">
                  <button
                    type="button"
                    className="ViewCertificationModal-renew-btn NewButton NewButton--bold h-40 ff-ss fz-16 lh-24"
                    onClick={handleRenew}
                  >
                    {startedAt
                      ? t('certifications.certificate.continue_renewal')
                      : t('certifications.certificate.renew')}
                  </button>
                </div>
              )}
              <button
                type="button"
                className="ViewCertificationModal-print-btn fd-r ai-c jc-c minw-120 h-40 bg-white ff-ss fz-16 lh-24 c-brand-night"
                onClick={handlePrintClicked}
              >
                <Printer size={16} className="mr-16" />
                {t('certifications.certificate.print')}
              </button>
              {path.certification.public && (
                <>
                  <div className="d-f fd-c pl-20">
                    <span className="c-brand-gray-darker lh-16">
                      {t('certifications.certificate.share_link')}
                    </span>
                    <input
                      className="ViewCertificationModal-urlInput NewInput--light w-240 h-40 mt-8 bdrs-2 lh-24 bg-white"
                      aria-label={t('certifications.certificate.share_link')}
                      onClick={handleClick}
                      ref={inputRef}
                      value={urls.share}
                      readOnly
                    />
                  </div>
                </>
              )}
            </div>
          </div>
          <div className="ViewCertificationModal-closeBtnContainer">
            <div className="ViewCertificationModal-btns-close d-f">
              <Button
                className="minw-120"
                onClick={toggleModal}
                primary={!expired}
              >
                {t('common.close')}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

ViewCertificationModal.propTypes = {
  shown: PropTypes.bool,
  toggleModal: PropTypes.func,
  pathProgressId: PropTypes.number,
};

export default ViewCertificationModal;
